<template>
    <div class="center tc">
        <img :src="image"/>
        <h5 class="mv3 w-50-ns center">{{description}}</h5>
        <router-link class="no-underline" v-if="buttonText !== null" :to="route">
            <TooliabaButton >{{buttonText}}</TooliabaButton>
        </router-link>
    </div>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        TooliabaButton
    },
    props: {
        image: {
            type: String
        },
        description: {
            type: String
        },
        buttonText: {
            type: String,
            default: null
        },
        route: {
            type: String
        }
    }
};
</script>
